class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    /* owner 2026-09-13d: a tick box knows its answer at once. Only the price
       boxes need a wait, so they do not fire a request on every digit typed. */
    this.debouncedOnSubmit = (function (self) {
      var timer;
      return function (event) {
        var t = event && event.target;
        var instant = t && (t.type === 'checkbox' || t.type === 'radio' || t.tagName === 'SELECT');
        clearTimeout(timer);
        timer = setTimeout(function () { self.onSubmitHandler(event); }, instant ? 0 : 700);
      };
    })(this);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {

    const endlessCollection = new Ajaxinate({
container: '#product-grid',
pagination: '.infinite_next',
});
    
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


// owner 2026-09-12: a price band fills the from/to boxes and lets the facet form do the rest
document.addEventListener('click', (event) => {
  const button = event.target.closest('.price-band');
  if (!button) return;
  const form = button.closest('form');
  if (!form) return;
  const from = form.querySelector('input[id$="-GTE"]');
  const to = form.querySelector('input[id$="-LTE"]');
  if (!from || !to) return;
  from.value = button.dataset.gte || '';
  to.value = button.dataset.lte || '';
  form
    .querySelectorAll('.price-band')
    .forEach((other) => other.classList.toggle('price-band--active', other === button));
  to.dispatchEvent(new Event('input', { bubbles: true }));
});
/* owner 2026-09-13: facet panel head + apply */
(function () {
  var SEL = '.facets-container .facets__disclosure';
  var DESKTOP_H = 420;   /* every desktop panel is this tall, so the row of
                            pills does not jump about as you click along it */
  var GAP = 24;

  function liveCount() {
    var el = document.getElementById('ProductCount') || document.getElementById('ProductCountDesktop');
    if (!el) return '';
    var m = (el.textContent || '').replace(/,/g, '').match(/\d+/);
    return m ? m[0] : '';
  }

  function panelTitle(details) {
    var s = details.querySelector('summary');
    if (!s) return '';
    var l = s.querySelector('.facets__summary-label');
    if (l) return l.textContent.trim();
    var sp = s.querySelector('div > span');
    return sp ? sp.textContent.trim() : '';
  }

  function closeIcon() {
    return '<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true" focusable="false">'
      + '<path d="M1.5 1.5l11 11M12.5 1.5l-11 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/></svg>';
  }

  /* Desktop: give the panel a definite height that always ends above the fold,
     so Reset and Apply are reachable without scrolling the page. Mobile is a
     fixed bottom sheet and sizes itself in CSS. */
  function sizePanel(details) {
    var panel = details.querySelector('.facets__display');
    if (!panel) return;
    if (window.innerWidth < 750 || !details.open) { panel.style.height = ''; return; }
    panel.style.height = '';
    var top = panel.getBoundingClientRect().top;
    var overshoot = top + DESKTOP_H + GAP - window.innerHeight;
    if (overshoot > 0) {
      window.scrollBy(0, overshoot);
      top = panel.getBoundingClientRect().top;
    }
    var avail = window.innerHeight - top - GAP;
    panel.style.height = Math.max(200, Math.min(DESKTOP_H, avail)) + 'px';
  }

  function decorate(details) {
    var panel = details.querySelector('.facets__display');
    if (!panel) return;

    /* 1. title bar with the close button */
    var head = panel.querySelector('.sm-facet-head');
    if (!head || head.parentNode !== panel) {
      head = document.createElement('div');
      head.className = 'sm-facet-head';
      var t = document.createElement('span');
      t.className = 'sm-facet-title';
      head.appendChild(t);
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'sm-facet-close';
      c.setAttribute('aria-label', 'Close');
      c.innerHTML = closeIcon();
      c.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        details.open = false;
      });
      head.appendChild(c);
      panel.insertBefore(head, panel.firstChild);
    }
    var titleEl = head.querySelector('.sm-facet-title');
    var tx = panelTitle(details);
    if (titleEl && titleEl.textContent !== tx) titleEl.textContent = tx;

    var foot = panel.querySelector('.facets__header');

    /* 2. the options go in a plain <div> of our own. Dawn puts them in a
       <fieldset>, and a fieldset cannot be a scroll container in Chrome: it
       reports the overflow but refuses to move, which is why the list would
       not scroll at any width. */
    var body = panel.querySelector('.sm-facet-body');
    if (!body || body.parentNode !== panel) {
      body = document.createElement('div');
      body.className = 'sm-facet-body';
      var move = [];
      for (var i = 0; i < panel.children.length; i++) {
        var ch = panel.children[i];
        if (ch === head || ch === foot) continue;
        if (ch.classList && ch.classList.contains('sm-facet-body')) continue;
        move.push(ch);
      }
      panel.appendChild(body);
      for (var j = 0; j < move.length; j++) body.appendChild(move[j]);
    }

    /* 3. Reset / Apply, always the last row */
    if (!foot) return;
    if (panel.lastElementChild !== foot) panel.appendChild(foot);
    var apply = foot.querySelector('.sm-facet-apply');
    if (!apply) {
      apply = document.createElement('button');
      apply.type = 'button';
      apply.className = 'sm-facet-apply';
      apply.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        details.open = false;
      });
      foot.appendChild(apply);
    }
    var n = liveCount();
    var label = n ? 'Apply (' + n + ' items)' : 'Apply';
    if (apply.textContent !== label) apply.textContent = label;

    if (!details.__smBound) {
      details.__smBound = 1;
      details.addEventListener('toggle', function () { sizePanel(details); });
    }
    if (details.open) sizePanel(details);
    markOpen();
  }

  function run() {
    var list = document.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) {
      try { decorate(list[i]); } catch (e) {}
    }
  }

  function boot() {
    var host = document.querySelector('.facets-container');
    if (!host) return;
    run();
    if (window.MutationObserver) {
      new MutationObserver(function () { run(); }).observe(host, { childList: true, subtree: true });
    }
    // the product count lives outside the panels; refresh Apply when it changes
    var counter = document.getElementById('ProductCount') || document.getElementById('ProductCountDesktop');
    if (counter && window.MutationObserver) {
      new MutationObserver(function () { run(); }).observe(counter, { childList: true, subtree: true, characterData: true });
    }
  }

  /* Safari on iPhone mis-handles a position:fixed panel that lives inside a
     horizontally scrolling container, which is exactly where the pills sit.
     Flag the document while a sheet is open so the CSS can drop the scroller,
     and so the floating widgets can be hidden without relying on :has(). */
  function markOpen() {
    var any = !!document.querySelector('.facets-container .facets__disclosure[open]');
    document.documentElement.classList.toggle('sm-facet-sheet', any);
  }
  document.addEventListener('toggle', markOpen, true);

  window.addEventListener('resize', function () {
    var open = document.querySelectorAll('.facets-container .facets__disclosure[open]');
    for (var i = 0; i < open.length; i++) sizePanel(open[i]);
  });

  // tapping the dimmed backdrop, or anywhere outside an open panel, closes it
  document.addEventListener('click', function (e) {
    var open = document.querySelectorAll('.facets-container .facets__disclosure[open]');
    for (var i = 0; i < open.length; i++) {
      var det = open[i];
      var sum = det.querySelector('summary');
      if (sum && sum.contains(e.target)) continue;
      var panel = det.querySelector('.facets__display');
      if (!panel) continue;
      if (panel.contains(e.target)) continue;
      det.open = false;
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
